<ng-container *ngIf="gridThumbnails?.length > 0">
    <div class="editor-header">
        <nb-actions size="small">
            <nb-action (click)="goBack($event)">
                <nb-icon icon="arrow-back-outline" pack="eva" title="Back"></nb-icon>Back
            </nb-action>
        </nb-actions>
        <div>Edit Banner - {{selectedSection?.sectionId}}</div>
    </div>
    <div *ngFor="let cellId of cellIdsThumbs;let i=index" class="section-thumbnail input-cell">
        <div class="thumbnail-img">
            <img src="{{cellId.imgSrc}}">
        </div>
        <div class="edit-options">
            <nb-actions size="small">
                <nb-action (click)="open({action:'image',imgSrc:cellId.imgSrc,cellId:cellId.cellId})">
                    <nb-icon icon="image-outline" pack="eva" title="Edit Image"></nb-icon>Image - {{cellId.cellId}}
                </nb-action>
                <nb-action (click)="open({action:'header',imgSrc:thumbnail})">
                    <nb-icon icon="browser-outline" pack="eva" title="Edit Header"></nb-icon>
                    Header</nb-action>
                <nb-action (click)="open({action:'footer',imgSrc:thumbnail})">
                    <nb-icon icon="book-outline" pack="eva" title="Edit Footer"></nb-icon>Footer</nb-action>
                <nb-action (click)="open({action:'link',imgSrc:thumbnail})">
                    <nb-icon icon="link-2-outline" pack="eva" title="Edit Link"></nb-icon>Link</nb-action>
                <nb-action (click)="download({cellId:cellId.cellId})">
                    <nb-icon icon="code-download-outline" pack="eva" title="Edit Link"></nb-icon>Down Load</nb-action>
            </nb-actions>
        </div>
    </div>   
</ng-container>
